import BigNumber from "bignumber.js";

export const formatBalance = (balance: string | null | undefined) => {
  if (!balance) return "0";
  const bn = BigNumber(balance);
  const eth = bn.dividedBy(BigNumber(10).pow(18));
  if (eth.isGreaterThanOrEqualTo(1000000)) {
    return `${eth.dividedBy(1000000).toFixed(2)}M`;
  }
  if (eth.isGreaterThanOrEqualTo(1000)) {
    return `${eth.dividedBy(1000).toFixed(2)}K`;
  }
  return eth.toFixed(4);
};
